/**
 * RPS-PREVENTION-ACTIONS-CARD
 * Mesures RPS (sans risque) dans les vues de mesures, a la suite des risques physiques.
 */
import Card from "@/components/card"
import { useRisksSpace } from "@/core/risks-space.context"
import { faHeart } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useState } from "react"
import { PreventionAction } from "../model/prevention-action.types"
import { PreventionMeasuresView } from "../model/prevention-action.utils"
import PreventionActionsChecklist from "./PreventionActionsChecklist"
import PreventionActionAddModal from "./modal/PreventionActionAddModal"

interface Props {
  measuresView: PreventionMeasuresView
  preventionActions: PreventionAction[]
  //Fonctions de depart d'une mesure ajoutee ici : celles du filtre, sinon tout l'etablissement
  populationIds: string[]
}

export default function RpsPreventionActionsCard({ measuresView, preventionActions, populationIds }: Props) {
  const { isReadonly } = useRisksSpace()
  const [isAdding, setIsAdding] = useState(false)

  return (
    <div className="mt-20">
      {isAdding && <PreventionActionAddModal rpsPopulationIds={populationIds} onClose={() => setIsAdding(false)} />}
      <Card isWithoutPadding className="mb-0 px-[30px] py-[20px]">
        <div className="mb-[10px] flex items-center gap-[14px] text-base font-bold">
          <FontAwesomeIcon className="grey-t" icon={faHeart} />
          Risques psychosociaux
        </div>
        <div className="mb-10">
          <PreventionActionsChecklist
            isReadonly={isReadonly}
            preventionActions={preventionActions}
            measuresView={measuresView}
            onAdd={() => setIsAdding(true)}
          />
        </div>
      </Card>
    </div>
  )
}
